import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface SectionHeaderProps {
  title: ReactNode
  description?: ReactNode
  actionSlot?: ReactNode
  className?: string
}

export function SectionHeader({
  title,
  description,
  actionSlot,
  className,
}: SectionHeaderProps) {
  const body = (
    <div className="min-w-0 flex flex-col">
      <h2 className="text-section text-foreground">{title}</h2>
      {description && (
        <p className="text-caption text-muted-foreground mt-0.5">{description}</p>
      )}
    </div>
  )

  if (actionSlot) {
    return (
      <div className={cn("mb-4 flex items-start justify-between gap-4", className)}>
        {body}
        <div className="shrink-0">{actionSlot}</div>
      </div>
    )
  }

  return <div className={cn("mb-4", className)}>{body}</div>
}
